import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-down",
  "use": "icon-chevron-down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-chevron-down\">\n  <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M16.001 7.807L14.934 6.5 10 10.886 5.066 6.5 3.999 7.807 10 13.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol